import { createSelector } from '@reduxjs/toolkit';

const animationDomain = state => state.animation;

export const reselectFireworkAnimation = createSelector(
    animationDomain,
    (animationState) => animationState.firework
);
